import Vue from 'vue'
import VueRouter from 'vue-router'
import { auth } from '../firebase'

import Dashboard from '../views/Dashboard.vue'
import Agenda from '../views/Agenda.vue'
import Events from '../views/Events.vue'
import Planning from '../views/Planning.vue'
import Modules from '../views/Modules.vue'
import Professors from '../views/Professors.vue'
import Rooms from '../views/Rooms.vue'
import Help from '../views/Help.vue'
import Settings from '../views/Settings.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/agenda',
    name: 'Agenda',
    component: Agenda,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/events',
    name: 'Events',
    component: Events,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/planning',
    name: 'Planning',
    component: Planning,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/modules',
    name: 'Modules',
    component: Modules,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/professors',
    name: 'Professors',
    component: Professors,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/rooms',
    name: 'Rooms',
    component: Rooms,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/help',
    name: 'Help',
    component: Help,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import( /* webpackChunkName: "settings" */ '../views/Settings.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import( /* webpackChunkName: "login" */ '../views/Login.vue'),
    props: route => ({
      gitlabAuthURI: 'https://gitlab-ce.iut.u-bordeaux.fr/oauth/authorize?client_id=212df2a3fdec0d2ef16458ed60432de8358012eca3759ad1914f4511658373ee&response_type=code&scope=read_user&redirect_uri=' + location.protocol + '//' + location.host + '/gitlab' + '&state=' + (location.host.startsWith("localhost") ? 'dev' : 'prod'),
      casAuthURI: 'https://cas.u-bordeaux.fr/cas/login?service=' + location.protocol + '//' + location.host + '/u-bordeaux.fr'
    }),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/gitlab',
    name: 'GitlabLogin',
    component: () => import('../views/GitlabLogin.vue'),
    props: route => ({
      code: route.query.code
    }),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/u-bordeaux.fr',
    name: 'CasLogin',
    component: () => import('../views/CasLogin.vue'),
    props: route => ({
      ticket: route.query.ticket
    }),
    meta: {
      requiresAuth: false
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// navigation guard to check for logged in users
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)

  if (requiresAuth && !auth.currentUser) {
    next('/login')
  } else if (!requiresAuth && auth.currentUser) {
    next('/dashboard')
  } else {
    next()
  }
})

export default router
